import { Component, HostBinding } from '@angular/core'
import { Router } from '@angular/router'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { ApplicationArea } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'growth-toolkit-landing',
   templateUrl: './landing-page.component.html',
   styleUrls: ['./landing-page.component.scss'],
   standalone: false,
})
export class GrowthToolkitLandingComponent {
   @HostBinding('class.full-flex-height') fullFlexHeight = true

   public canViewRegionalManagerSummary = false
   public canViewHospitalManagerDashboard = false
   public canViewDirectorSummary = false

   constructor(private authMgr: AuthManager, private router: Router) {
      this.authMgr.getCurrentUser().subscribe((user) => {
         console.log(user.roles)

         //first get permissions roles for this user
         var userHospitalManager = this.authMgr.canAccess(user, {
            application: ApplicationArea.HospitalManager,
            roleName: ['HospitalManager'],
         })
         var userRM = this.authMgr.canAccess(user, {
            application: ApplicationArea.RM,
            roleName: ['RM'],
         })
         var userOpsDirector = this.authMgr.canAccess(user, {
            application: ApplicationArea.OpsDirector,
            roleName: ['OpsDirector'],
         })
         var userOpsVP = this.authMgr.canAccess(user, {
            application: ApplicationArea.OpsVP,
            roleName: ['OpsVP'],
         })

         //then convert those permissions roles to viewable sections of html
         this.canViewRegionalManagerSummary = userRM || userOpsDirector || userOpsVP
         this.canViewHospitalManagerDashboard = userHospitalManager
         this.canViewDirectorSummary = userOpsDirector || userOpsVP
      })
   }
}
